import { isoDate, shiftIsoDate } from "../../shared/format";

/**
 * Đường dẫn màn Báo cáo doanh thu — cũng là màn hình (ADR-0053) mà số doanh thu trên Tổng quan
 * thuộc về. `DashboardPage` hỏi gói bằng đúng đường dẫn này: hiện số thì phải vào được báo cáo đứng
 * sau số đó.
 */
export const REVENUE_REPORT_PATH = "/reports/revenue";

/**
 * Hôm qua → hôm nay, theo GIỜ ĐỊA PHƯƠNG (#19847) — đủ cho thẻ "Thực thu hôm nay" và phép so với
 * hôm qua của nó.
 *
 * #19900: Tổng quan không còn widget 7 ngày, nên không còn lý do xin 7 ngày. Widget đó hiện số
 * "phát sinh" ngay dưới thẻ "thực thu" — hai con số "doanh thu hôm nay" khác nghĩa đứng cạnh nhau.
 */
export function revenueTodayRange(now: Date = new Date()): { from: string; to: string } {
  return { from: shiftIsoDate(now, -1), to: isoDate(now) };
}
